// create the module before importing the sub-resources, as they don't each
// make their own angular module because reasons
let module = angular.module('app.resources', []);

// The act of importing these actually registers them with the angular module
// from above, so we're good to go at this point.
require('./account');
require('./account_reseller');
require('./activation-codes');
require('./analytics');
require('./apple_tv_app');
require('./boxcaster');
require('./broadcast');
require('./caption');
require('./channel');
require('./broadcast-tags');
require('./donation');
require('./facebook_user');
require('./geolocation');
require('./highlight');
require('./order');
require('./twitter_user');
require('./podcast');
require('./recording');
require('./requester-address');
require('./roku_app');
require('./rtmp_push_channel');
require('./scoreboard-assist-firmware');
require('./srt-source');
require('./static-rtmp');
require('./ticket');
require('./user');
require('./user_capabilities');
require('./vimeo_user');
require('./youtube_user');
require('./products');
require('./sites');
require('./ott');

export default module;



// WEBPACK FOOTER //
// ./app/resources/_index.js